import React, { useState } from "react";
import { Button } from "../Button";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { ResultForm } from "./ResultForm";
import { useAddResult } from "../../hooks/resultsHooks/results.hooks";
import { validateResultData } from "../../Helper/validation/resultData.validation.helper";

export const AddResult = () => {
  const dispatch = useDispatch();

  const [schoolBranchId, setSchoolBranchId] = useState<number | null>(null);
  const [selectedClass, setSelectedClass] = useState<number | null>(null);
  const [publishDate, setPublishDate] = useState("");
  const [resultType, setResultType] = useState("");
  const [totalAttendance, setTotalAttendance] = useState<number | null>(null);

  const resetResultState = () => {
    setSchoolBranchId(null);
    setSelectedClass(null);
    setPublishDate("");
    setResultType("");
    setTotalAttendance(0);
  };

  const { isLoading: isSavingResult, mutate: addResult } = useAddResult({
    onSuccess: () => {
      dispatch(setSuccessMessage("Branch added successfully."));
      resetResultState();
    },
    onError: (error: any) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleAddResult = () => {
    if (
      !validateResultData(
        {
          resultType,
          schoolBranchId,
          totalAttendance,
        },
        dispatch,
      )
    ) {
      return;
    }

    addResult({
      school_branch_id: schoolBranchId as number,
      class_id: selectedClass as number,
      publish_date: publishDate,
      result_type: resultType,
      days_before_exam: totalAttendance as number,
    });
  };

  return (
    <div>
      <div>
        <ResultForm
          schoolBranchId={schoolBranchId}
          onBranchSelect={(branchId) => {
            if (branchId) {
              setSchoolBranchId(branchId);
            }
          }}
          selectedClass={selectedClass}
          onClassSelect={(classId) => {
            if (classId) {
              setSelectedClass(classId);
            }
          }}
          totalAttendance={totalAttendance}
          setTotalAttendance={setTotalAttendance}
          publishDate={publishDate}
          setPublishDate={setPublishDate}
          onResultTypeSelect={setResultType}
          resultType={resultType}
        />
      </div>
      <div>
        <Button
          loading={isSavingResult}
          text="Save"
          onClick={handleAddResult}
        />
      </div>
    </div>
  );
};
